"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VKVideo1Schema = void 0;
exports.VKVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/vk-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "VKVideo1",
    "description": "Embed a VK.com video",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:vk-video:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "hash": {
                    "type": "string",
                    "description": "vk.com hash for the widget connection (vk query parameter 'hash')"
                },
                "ownerId": {
                    "type": "string",
                    "description": "vk.com owner id of a post (vk query parameter 'oid')"
                },
                "videoId": {
                    "type": "string",
                    "description": "vk.com video ID (query parameter 'id')"
                }
            },
            "required": [
                "hash",
                "ownerId",
                "videoId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy92ay12aWRlby8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGNBQWMsR0FBRztJQUM1QixLQUFLLEVBQUUsNkVBQTZFO0lBQ3BGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLFVBQVU7SUFDbkIsYUFBYSxFQUFFLHNCQUFzQjtJQUNyQyxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04scUNBQXFDO2FBQ3RDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osTUFBTSxFQUFFO29CQUNOLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsbUVBQW1FO2lCQUNuRjtnQkFDRCxTQUFTLEVBQUU7b0JBQ1QsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxzREFBc0Q7aUJBQ3RFO2dCQUNELFNBQVMsRUFBRTtvQkFDVCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLHdDQUF3QztpQkFDeEQ7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixNQUFNO2dCQUNOLFNBQVM7Z0JBQ1QsU0FBUzthQUNWO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=